import axios from 'axios';
import React from 'react'
import { baseUrl } from '../assets/Animations';
import './ugly-cancellations.css'
import UglyCancellationsPopup from './UglyCancellationsPopup/UglyCancellationsPopup';
import { getRequestHeaders } from '../api';

const normalizeName = (value) =>
    String(value || '')
        .trim()
        .replace(/\s+/g, ' ')
        .toLowerCase()

const UglyCancellations = () => {
    const [cancellations, setCancellations] = React.useState([])
    const [families, setFamilies] = React.useState([])
    const [teachers, setTeachers] = React.useState([])
    const [teacherCancelled, setTeacherCancelled] = React.useState({})
    const [familyCancelled, setFamilyCancelled] = React.useState({})
    const [teacherCancellations, setTeacherCancellations] = React.useState([])
    const [familyCancellations, setFamilyCancellations] = React.useState([])
    const [showPopup, setShowPopup] = React.useState(false)

    React.useEffect(() => {
        axios.get(`${baseUrl}/cancellation`, getRequestHeaders())
        .then(res => {setCancellations(Array.isArray(res.data) ? res.data : [])})
        .catch(err => {console.log(err)})

        axios.get(`${baseUrl}/school-management/`, getRequestHeaders())
        .then(res => {setFamilies(Array.isArray(res.data) ? res.data : [])})
        .catch(err => {console.log(err)})

        axios.get(`${baseUrl}/initialadminrequest`, getRequestHeaders())
        .then(res => {setTeachers(Array.isArray(res.data) ? res.data : [])})
        .catch(err => {console.log(err)})
    }, [])

    React.useEffect(() => {
        const teachersById = new Map(
            teachers.map((teacher) => [String(teacher.TeacherID), teacher])
        )

        const familiesById = new Map(
            families.map((family) => [String(family.familyId), family])
        )

        const isActiveTeacherCancellation = (cancellation) => {
            const teacher = teachersById.get(String(cancellation.teacherId || ''))
            return teacher?.Status === 'Active'
        }

        const isActiveFamilyOrStudentCancellation = (cancellation) => {
            const family = familiesById.get(String(cancellation.familyId || ''))

            if (!family) {
                return false
            }

            if (family.familyStatus === 'Active') {
                return true
            }

            const normalizedCancellationStudentName = normalizeName(cancellation.studentName)
            const matchingStudent = (family.students || []).find((student) => {
                return (
                    String(student.studentId || '') === String(cancellation.studentId || '') ||
                    normalizeName(student.studentName) === normalizedCancellationStudentName
                )
            })

            return matchingStudent?.studentStatus === 'Active'
        }

        const filteredCancellations = cancellations.filter((cancellation) => {
            return (
                isActiveTeacherCancellation(cancellation) &&
                isActiveFamilyOrStudentCancellation(cancellation)
            )
        })

        const teacherCancellations = filteredCancellations.filter(cancellation => cancellation.teacherCancelled === true)
        const familyCancellation = filteredCancellations.filter(cancellation => cancellation.teacherCancelled === false)
        setTeacherCancellations(teacherCancellations)
        setFamilyCancellations(familyCancellation)
        setTeacherCancelled(organizeCancellationsByTeacherName(teacherCancellations))
        setFamilyCancelled(organizeCancellationsByFamilyName(familyCancellation))
    }
    , [cancellations, families, teachers])

    //ORGANIZE CANCELLATIONS BY If teacherCancelled is true or not
    //if teacherCancelled is true, then ORGANIZE by teacherName
    //if teacherCancelled is false, then ORGANIZE by familyName

    const organizeCancellationsByFamilyName = (cancellations) => {
        const cancellationsByFamilyName = {}
        cancellations.forEach(cancellation => {
            if(!cancellationsByFamilyName[cancellation.familyName]) {
                cancellationsByFamilyName[cancellation.familyName] = []
            }
            cancellationsByFamilyName[cancellation.familyName].push(cancellation)
        })
        return sortByLongestArray(cancellationsByFamilyName)
    }

    const organizeCancellationsByTeacherName = (cancellations) => {
        const cancellationsByTeacherName = {}
        cancellations.forEach(cancellation => {
            if(!cancellationsByTeacherName[cancellation.teacherName]) {
                cancellationsByTeacherName[cancellation.teacherName] = []
            }
            cancellationsByTeacherName[cancellation.teacherName].push(cancellation)
        })
        //sort cancellationsbyteachername by who has the most cancellations


        return sortByLongestArray(cancellationsByTeacherName)
    }

    function sortByLongestArray(obj) {
        const keys = Object.keys(obj);
      
        keys.sort((key1, key2) => {
          const arrayLength1 = Array.isArray(obj[key1]) ? obj[key1].length : 0;
          const arrayLength2 = Array.isArray(obj[key2]) ? obj[key2].length : 0;
          return arrayLength2 - arrayLength1;
        });
      
        const sortedObj = {};
        keys.forEach(key => {
          sortedObj[key] = obj[key];
        });
      
        return sortedObj;
      }



      return (
        <div className="cancellation-container">
          <div className="cancellation-column">
            <div className='cancellation-header-row'>
              <div>
                <div className='cancellation-kicker'>Active Families / Students</div>
                <div className='cancellation-header'>Family Cancellations</div>
              </div>
              <div className='cancellation-total-chip'>{familyCancellations.length}</div>
            </div>
            <div className='cancellations-wrapper'>
              {Object.keys(familyCancelled).map((key) => (
                <div
                  key={key}
                  className='each-cancellation'
                  onClick={() => setShowPopup(familyCancelled[key])}
                >
                  <div className='each-cancellation__name'>{key}</div>
                  <div className='each-cancellation__count'>{familyCancelled[key].length}</div>
                </div>
              ))}
            </div>
          </div>
          <div className="cancellation-column">
            <div className='cancellation-header-row'>
              <div>
                <div className='cancellation-kicker'>Active Teachers</div>
                <div className='cancellation-header'>Teacher Cancellations</div>
              </div>
              <div className='cancellation-total-chip'>{teacherCancellations.length}</div>
            </div>
            <div className='cancellations-wrapper'>
              {Object.keys(teacherCancelled).map((key) => (
                <div
                  key={key}
                  className='each-cancellation'
                  onClick={() => setShowPopup(teacherCancelled[key])}
                >
                  <div className='each-cancellation__name'>{key}</div>
                  <div className='each-cancellation__count'>{teacherCancelled[key].length}</div>
                </div>
              ))}
            </div>
          </div>
          {showPopup && <UglyCancellationsPopup cancellations={showPopup} setShowPopup={setShowPopup} />}
        </div>
      );
}
export default UglyCancellations;
